module.exports = __webpack_public_path__ + "static/media/JH_web_2.43568295.jpg";